/**
 * LD Cart Operations - Cart manipulation functions
 */

class LDCartOperations {
  constructor(cartDrawer) {
    this.cartDrawer = cartDrawer;
  }

  async updateQuantity(lineItemId, change) {
    if (this.cartDrawer.isUpdating) return;
    
    console.log(`LD Cart Operations: Updating quantity for line item ${lineItemId}, change: ${change}`);
    
    try {
      // First get current cart to find current quantity
      const cartResponse = await fetch('/cart.js');
      const cartData = await cartResponse.json();
      
      // Find the line item
      const lineItem = cartData.items.find(item => item.id.toString() === lineItemId.toString());
      if (!lineItem) {
        console.error('LD Cart Operations: Line item not found in cart');
        return;
      }
      
      // Calculate new quantity
      const newQuantity = Math.max(0, lineItem.quantity + change);
      console.log(`LD Cart Operations: Current quantity: ${lineItem.quantity}, new quantity: ${newQuantity}`);
      
      if (newQuantity === 0) {
        // Remove item if quantity becomes 0
        await this.removeLineItem(lineItemId);
        return;
      }
      
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: lineItemId,
          quantity: newQuantity
        })
      });
      
      if (response.ok) {
        await this.cartDrawer.refreshCart();
        console.log('LD Cart Operations: Quantity updated successfully');
      } else {
        console.error('LD Cart Operations: Failed to update quantity');
      }
    } catch (error) {
      console.error('LD Cart Operations: Error updating quantity:', error);
    }
  }

  async setQuantity(lineItemId, quantity) {
    if (this.cartDrawer.isUpdating) return;
    
    console.log(`LD Cart Operations: Setting quantity for line item ${lineItemId} to ${quantity}`);
    
    try {
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: lineItemId,
          quantity: quantity
        })
      });
      
      if (response.ok) {
        await this.cartDrawer.refreshCart();
        console.log('LD Cart Operations: Quantity set successfully');
      } else {
        console.error('LD Cart Operations: Failed to set quantity');
      }
    } catch (error) {
      console.error('LD Cart Operations: Error setting quantity:', error);
    }
  }

  async removeLineItem(lineItemId) {
    if (this.cartDrawer.isUpdating) return;
    
    console.log(`LD Cart Operations: Removing line item ${lineItemId}`);
    
    try {
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: lineItemId,
          quantity: 0
        })
      });
      
      if (response.ok) {
        await this.cartDrawer.refreshCart();
        console.log('LD Cart Operations: Line item removed successfully');
      } else {
        console.error('LD Cart Operations: Failed to remove line item');
      }
    } catch (error) {
      console.error('LD Cart Operations: Error removing line item:', error);
    }
  }

  async addToCart(variantId, quantity = 1, properties = {}) {
    console.log(`LD Cart Operations: Adding variant ${variantId} to cart with quantity ${quantity}`);
    
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: variantId,
          quantity: quantity,
          properties: properties
        })
      });
      
      if (response.ok) {
        const result = await response.json();
        console.log('LD Cart Operations: Item added to cart successfully:', result);
        return result;
      } else {
        const error = await response.json();
        console.error('LD Cart Operations: Failed to add item to cart:', error);
        throw new Error(error.description || 'Failed to add item to cart');
      }
    } catch (error) {
      console.error('LD Cart Operations: Error adding item to cart:', error);
      throw error;
    }
  }
}

// Make class globally available
window.LDCartOperations = LDCartOperations;
